export const HOUSING_BUDGET_CODE = "HOUSING";
export const SAVINGS_BUDGET_CODE = "SAVINGS";
export const EMERGENCY_BUDGET_CODE = "EMERGENCY";
// The emergency category data is a bit different from the other categories. We
// use the option label to determine the image to display and the descriptions
// are long, so we map labels to short descriptions here. In the future we could
// consider adding `code` or `image_name` columns to the database table instead,
// at which point we could just use the label like we do for the other
// categories.
export const EMERGENCY_BUDGET_DESCRIPTIONS = {
  HOME: "Your sink broke",
  MEDICAL: "Emergency room visit",
  PET: "Emergency vet visit",
};
